import React, {Component} from "react";
import {injectIntl} from "react-intl";
import axios from "axios";
import {connect} from "react-redux";
import {Button, Card, Form, Input, message, Modal, Spin, Table} from "antd";
import style from '../UsersPage/UserList.less'
import {
  PlusSquareTwoTone,
  EditTwoTone,
  DeleteTwoTone,
  SettingTwoTone, ToolTwoTone
} from '@ant-design/icons';
const FormItem = Form.Item;

class RoleList extends Component {

  state = {
    loading: false,
    current: 0,
    size: 10,
    total: 0,
    data: [],
    selectedRowId: "",
    visible: false,
    operation: "",
    title: "",
    roleName: "",
    roleDescription: ""
  };

  componentDidMount() {
    this.fetchData(this.props.enterpriseId, this.state.current, this.state.size);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.enterpriseId === null && this.props.enterpriseId !== null) {
      this.fetchData(this.props.enterpriseId, this.state.current, this.state.size);
    }
  }

  render() {
    const nameCol = this.language("user_service_role_list_name_col");
    const descriptionCol = this.language("user_service_role_list_description_col");
    const addRoleModalName = this.language("user_service_role_list_add_role_modal_name");
    const addRoleModalNamePlaceholder = this.language("user_service_role_list_add_role_modal_name_placeholder");
    const addRoleModalDescription = this.language("user_service_role_list_add_role_modal_description");
    const addRoleModalDescriptionPlaceholder = this.language("user_service_role_list_add_role_modal_description_placeholder");
    const deleteRoleModalDescription = this.language("user_service_role_list_delete_role_modal_description");
    const panelTitle = this.language("user_service_role_list_panel_title");
    const modalOk = this.language("user_service_role_list_modal_ok");
    const modalCancel = this.language("user_service_role_list_modal_cancel");
    const addBtn = this.language("user_service_role_list_add_btn");
    const modifyBtn = this.language("user_service_role_list_modify_btn");
    const deleteBtn = this.language("user_service_role_list_delete_btn");
    const configUserBtn = this.language("user_service_role_list_config_user_btn");
    const configPrivilegeBtn = this.language("user_service_role_list_config_privilege_btn");
    const addRoleModalTitle = this.language("user_service_role_list_add_role_modal_title");
    const modifyRoleModalTitle = this.language("user_service_role_list_modify_role_modal_title");
    const acquireRoleModalFailTxt = this.language("user_service_role_list_acquire_role_modal_fail_txt");
    const deleteRoleModalTitle = this.language("user_service_role_list_delete_role_title");
    const addRoleModalSuccessTxt = this.language("user_service_role_list_add_role_modal_success");
    const addRoleModalFailTxt = this.language("user_service_role_list_add_role_modal_fail");
    const deleteRoleModalSuccessTxt = this.language("user_service_role_list_delete_role_modal_success");
    const deleteRoleModalFailTxt = this.language("user_service_role_list_delete_role_modal_fail");
    const modifyRoleModalSuccessTxt = this.language("user_service_role_list_modify_role_modal_success");
    const modifyRoleModalFailTxt = this.language("user_service_role_list_modify_role_modal_fail");
    const unknownModal = this.language("user_service_role_list_unknown_modal");


    const rowSelection = {
      type: "radio",
      selectedRowKeys: this.state.selectedRowId,
      onChange: (selectedRowKeys, selectedRows) => {
        console.debug(`RoleList: selectedRowKeys ${selectedRowKeys} selectedRows ${selectedRows}`);
        let row = selectedRowKeys;
        if (selectedRowKeys[0] === this.state.selectedRowId[0]) {
          console.debug("RoleList: selection not change");
          row = ""
        }
        this.setState({
          selectedRowId: row
        })
      },
      onSelect: (record, selected, selectedRows) => {
        console.debug(`RoleList: ${record}, ${selected}, ${selectedRows}`);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        console.debug(`RoleList: ${selected}, ${selectedRows}, ${changeRows}`);
      },
      getCheckboxProps: record => ({
        disabled: record.name === 'Disabled User',
      }),
    };

    const pagination = {
      pageSize: this.state.size,
      current: this.state.current + 1,
      total: this.state.total,
      showSizeChanger: true,
      pageSizeOptions: ['10', '20', '30'],
      onShowSizeChange: (current, size) => {
        console.debug("RoleList: page", current, "size", size);
        this.setState({
          current: current - 1,
          size: size
        });
        this.fetchData(this.props.enterpriseId, current - 1, size);
      },
      onChange: (page) => {
        console.debug("RoleList: page", page);
        this.setState({
          current: page - 1
        });
        this.fetchData(this.props.enterpriseId, page - 1, this.state.size);
      }
    };

    const columns = [{
      title: nameCol,
      dataIndex: "name",
      key: "name",
      width: "120px",
    }, {
      title: descriptionCol,
      dataIndex: "description",
      key: "description",
      width: "240px"
    }];

    const data = this.state.data;

    let modalContent = (
      <Form>
        <FormItem
          label={addRoleModalName}
          hasFeedback
          validateStatus="">
          <Input name="roleName"
                 placeholder={addRoleModalNamePlaceholder}
                 value={this.state.roleName}
                 onChange={this.onInput.bind(this)}/>
        </FormItem>
        <FormItem
          label={addRoleModalDescription}
          hasFeedback
          validateStatus=""
        >
          <Input name="roleDescription"
                 type="textarea"
                 rows={4}
                 placeholder={addRoleModalDescriptionPlaceholder}
                 value={this.state.roleDescription}
                 onChange={this.onInput.bind(this)}/>
        </FormItem>
      </Form>
    );

    if (this.state.operation === "delete") {
      modalContent = (
        <div>{`${deleteRoleModalDescription}: ${this.state.roleName} - ${this.state.roleDescription}?`}</div>
      )
    }


    return (
      <div style={{background: "white", height: "100vh"}}>
        <Spin spinning={this.state.loading} size="large">
          <Card title={panelTitle}  headStyle={{
            height:"50px",fontSize:"18px",
            lineHeight:"18px",fontWeight:"bold",color:"#394365",padding:'0 20px'}} bodyStyle={{
            padding:"20px"
          }}>
            <div style={{
              display: "flex",
              flexDirection: "column",
              margin: "0 auto",
              background: "white"
            }}>
              <Modal title={this.state.title}
                     visible={this.state.visible}
                     okText={modalOk}
                     cancelText={modalCancel}
                     onOk={() => this.handleOk.bind(this)(addRoleModalSuccessTxt, addRoleModalFailTxt, deleteRoleModalSuccessTxt, deleteRoleModalFailTxt, modifyRoleModalSuccessTxt, modifyRoleModalFailTxt, unknownModal)}
                     onCancel={this.handleCancel.bind(this)}>
                {modalContent}
              </Modal>
              <div style={{
                marginBottom: "10px"
              }}>
                <Button style={{marginRight: "10px"}}
                        onClick={() => this.onCreate.bind(this)(addRoleModalTitle)}>
                  <PlusSquareTwoTone />
                  {addBtn}
                </Button>
                <Button style={{marginRight: "10px"}}
                        disabled={this.state.selectedRowId === ""}
                        onClick={() => this.onModify.bind(this)(modifyRoleModalTitle, acquireRoleModalFailTxt)}>
                  <EditTwoTone />
                  {modifyBtn}
                </Button>
                <Button style={{marginRight: "10px"}}
                        disabled={this.state.selectedRowId === ""}
                        onClick={() => this.onDelete.bind(this)(deleteRoleModalTitle, acquireRoleModalFailTxt)}>
                  <DeleteTwoTone />
                  {deleteBtn}
                </Button>
                <Button style={{marginRight: "10px"}}
                        disabled={this.state.selectedRowId === ""}
                        onClick={this.onUserConfig.bind(this)}>
                  <SettingTwoTone />
                  {configUserBtn}
                </Button>
                <Button style={{marginRight: "10px"}}
                        disabled={this.state.selectedRowId === ""}
                        onClick={this.onPrivilegeConfig.bind(this)}>
                  <ToolTwoTone />
                  {configPrivilegeBtn}
                </Button>
              </div>
              <div>
                <Table
                  rowSelection={rowSelection}
                  columns={columns}
                  dataSource={data}
                  pagination={pagination}
                  size="small"
                  bordered
                />
              </div>

            </div>
          </Card>
        </Spin>
      </div>
    )
  }

  fetchData(company, current, size) {
    this.setState({
      loading: true
    });

    axios({
      url: `/api-user/enterprisesRoles?enterpriseId=${company}&page=${current}&size=${size}`,
      method: "GET"
    }).then(
      response => {
        console.debug("RoleList: GET /enterprises/{enterpriseId}/roles", response.data);
        this.setState({
          loading: false,
          current: response.data.pageable.pageNumber,
          size: response.data.pageable.pageSize,
          total: response.data.totalElements,
          data: response.data.content.map(value => {
            return {
              key: value.id,
              name: value.name,
              description: value.description,
              code: value.code,
              enterprise: value.enterprise
            }
          })
        })
      },
      err => {
        console.error("RoleList: GET /enterprises/{enterpriseId}/roles");
      }
    ).catch(
      ex => {
        console.error("RoleList: GET /enterprises/{enterpriseId}/roles");
      }
    )
  }

  onCreate(addRoleModalTitle) {
    this.setState({
      visible: true,
      title: addRoleModalTitle,
      operation: "create",
      roleName: "",
      roleDescription: ""
    });
  }

  onModify(title, failTxt) {
    axios({
      url: `/api-user/roles/${this.state.selectedRowId[0]}`,
      method: "GET"
    }).then(
      response => {
        this.setState({
          roleName: response.data.name,
          roleDescription: response.data.description,
          visible: true,
          title: title,
          operation: "modify"
        })
      },
      err => {
        message.error(failTxt);
      }
    ).catch(
      ex => {
        message.error(failTxt);
      }
    );

  }

  onDelete(title, failTxt) {
    axios({
      url: `/api-user/roles/${this.state.selectedRowId[0]}`,
      method: "GET"
    }).then(
      response => {
        this.setState({
          visible: true,
          title: title,
          operation: "delete",
          roleName: response.data.name,
          roleDescription: response.data.description
        })
      },
      err => {
        message.error(failTxt);
      }
    ).catch(
      ex => {
        message.error(failTxt);
      }
    );
  }

  onInput(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleOk(successTxt, failTxt, deleteSuccessTxt, deleteFailTxt, modifySuccessTxt, modifyFailTxt, unknownFailTxt) {
    this.setState({
      visible: false
    })

    if (this.state.operation === "create") {
      axios({
        url: `/api-user/enterprises/${this.props.enterpriseId}/roles`,
        method: "POST",
        data: {
          name: this.state.roleName,
          description: this.state.roleDescription
        }
      }).then(
        response => {
          this.fetchData(this.props.enterpriseId, this.state.current, this.state.size);
          console.debug("RoleList: POST /enterprises/{enterpriseId}/roles", response.data);
          message.success(successTxt);
        },
        err => {
          message.error(failTxt);
        }
      ).catch(
        ex => {
          message.error(failTxt);
        }
      )
    } else if (this.state.operation === "delete") {
      let roleId = this.state.selectedRowId[0];
      axios({
        url: `/api-user/enterprises/${this.props.enterpriseId}/roles/${roleId}`,
        method: "DELETE"
      }).then(
        response => {
          this.fetchData(this.props.enterpriseId, 0, this.state.size);
          console.debug("RoleList: DELETE /enterprises/{enterpriseId}/roles/{roleIds}", response.data);
          message.success(deleteSuccessTxt);
        },
        err => {
          message.error(deleteFailTxt);
        }
      ).catch(
        ex => {
          message.error(deleteFailTxt);
        }
      )
    } else if (this.state.operation === "modify") {
      axios({
        url: `/api-user/roles/${this.state.selectedRowId[0]}`,
        method: "PATCH",
        data: {
          name: this.state.roleName,
          description: this.state.roleDescription
        }
      }).then(
        response => {
          this.fetchData(this.props.enterpriseId, this.state.current, this.state.size);
          message.success(modifySuccessTxt);
        },
        err => {
          message.error(modifyFailTxt, err);
        }
      ).catch(
        ex => {
          message.error(modifyFailTxt, ex);
        }
      )
    } else {
      message.error(unknownFailTxt);
    }
  }

  handleCancel() {
    this.setState({
      visible: false
    })
  }

  onUserConfig() {
    const roleName = this.state.data.filter(d => d.key === this.state.selectedRowId[0])[0].name;
    this.props.dispatch({
      type: "/role-list/SELECT_ROLE",
      roleName: roleName,
      roleId: this.state.selectedRowId[0]
    });
    console.debug("RoleList: pick roleName", roleName);
    this.props.history.push("/console/user-role-config");
  }

  onPrivilegeConfig() {
    const roleName = this.state.data.filter(d => d.key === this.state.selectedRowId[0])[0].name;
    this.props.dispatch({
      type: "/role-list/SELECT_ROLE",
      roleName: roleName,
      roleId: this.state.selectedRowId[0]
    });
    console.debug("RoleList: pick roleName:", roleName);
    this.props.history.push("/console/privilege-role-config");
  }

  language(value) {
    return this.props.intl.formatMessage({id: value});
  }
}

export const roleListReducer = (state = {roleName: ""}, action) => {
  switch (action.type) {
    case "/role-list/SELECT_ROLE":
      return {
        ...state,
        roleName: action.roleName,
        roleId: action.roleId
      };
    default:
      return state
  }
};

export const mapStateToProps = (state) => ({
  enterpriseId: state.userData.enterprises[state.userData.currentEnterprise] ? state.userData.enterprises[state.userData.currentEnterprise].id : null
});

export const mapDispatchToProps = (dispatch) => ({
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RoleList));
